import clsx from 'clsx';
import { useCallback } from 'react';

import styles from '../../Slider.module.scss';

interface DotsNavigationProps {
  /** Number of dot buttons to render */
  dots: number;
  /** Current selected dot button  */
  selected: number;
  /** Callback triggered on button click */
  onClick: (value: number) => void;
}

export function DotsNavigation({
  dots,
  selected,
  onClick,
}: DotsNavigationProps) {
  const handleClick = useCallback(
    (index: number) => () => {
      onClick(index);
    },
    [onClick],
  );

  if (dots < 2) return null;

  const dotsMarkup = [...new Array(dots)].map((_, index) => (
    <li key={`Dot${index}`} className={styles.Dot}>
      <button
        aria-current={selected === index ? true : undefined}
        className={clsx(
          styles.DotButton,
          selected === index && styles['DotButton--active'],
        )}
        onClick={handleClick(index)}
      >
        <span className={styles.DotContent}>{`Go to slide ${index + 1}`}</span>
      </button>
    </li>
  ));

  return (
    <nav>
      <ul className={styles.Dots}>{dotsMarkup}</ul>
    </nav>
  );
}
